;(function ($) {})(jQuery)
